module.exports = __webpack_public_path__ + "img/Warrior-nightelf-f-60.968d20e8.gif";